import { useEffect, useState } from "react";
import { BsStarFill } from "react-icons/bs";
import { MdUpdate } from "react-icons/md";
import { BiLinkExternal } from "react-icons/bi";
import { AiOutlineDownload, AiOutlineFormatPainter } from "react-icons/ai";
import { Social } from "./Footer";
function UpdatedText(text) {
  return (
    <>
      <p className="updated-text">
        <MdUpdate className="update-symbol" /> Actualizado el {text}
      </p>
    </>
  );
}
export default function ProductHolder(props) {
  const [template, setTemplate] = useState();
  const [publicLink, setPublicLink] = useState();
  let productDate = new Date(props.fecha);
  const meses = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];
  productDate =
    productDate.getDate() +
    " de " +
    meses[productDate.getMonth()] +
    " del " +
    productDate.getFullYear();
  const [updated, setUpdated] = useState("");
  const [redeemed, setRedemeed] = useState(<></>);
  const [loaded, setLoaded] = useState(false);
  const [isNew, newBadge] = useState(<></>);
  const [updatedBadge, setUpdatedBadge] = useState(<></>);
  useEffect(
    (e) => {
      props.public
        ? setPublicLink(
            <>
              <h2 className="product-title">
                {isNew}
                {updatedBadge}{" "}
                <a
                  title="Ver producto en Shoppy"
                  href={props.public}
                  target="_blank"
                  rel="noreferrer"
                  className="product-title underlined"
                >
                  {<BiLinkExternal />}
                  {props.name} - {props.category}
                </a>
              </h2>
            </>,
          )
        : setPublicLink(
            <h2 className="product-title">
              {isNew}
              {updatedBadge}
              {props.name} - {props.category}
            </h2>,
          );
    },
    [isNew],
  );
  if (props.valid == false) {
    return <></>;
  }
  if (!loaded) {
    if (props.isNew == true)
      newBadge(
        <span
          title="Este mod se creó hace menos de 3 meses"
          className="new-badge"
        >
          Nuevo
        </span>,
      );
    if (props.updated) {
      setUpdated(UpdatedText(productDate));
      setUpdatedBadge(
        <span
          title={"Actualizado el " + productDate}
          className="new-badge update-badge"
        >
          Actualizado
        </span>,
      );
    }
    if (props.canAccessTemplates && props.template && !loaded) {
      setTemplate(
        <>
          <a
            href={props.template}
            target="_blank"
            rel="noreferrer"
            className="updated-text template-text"
          >
            <p className="updated-text template-text">
              {<AiOutlineFormatPainter />}Descargar template
            </p>
          </a>
        </>,
      );
    }
    props.public
      ? setPublicLink(
          <>
            {isNew}
            {updatedBadge}
            <a
              title="Ver producto en Shoppy"
              href={props.public}
              target="_blank"
              rel="noreferrer"
              className="product-title underlined"
            >
              <h2 className="product-title">
                {props.name} - {props.category}
              </h2>
            </a>
          </>,
        )
      : setPublicLink(
          <h2 className="product-title">
            {isNew}
            {updatedBadge}
            {props.name} - {props.category}
          </h2>,
        );
    setRedemeed(<></>);
    if (props.redeemed != undefined || props.redeemed != null) {
      setRedemeed(
        <p className="redeem-mod">Canjeado por ti el {props.redeemed}</p>,
      );
    }
    if (props.redeemed == "today") {
      setRedemeed(<p className="redeem-mod">Canjeado por ti hoy</p>);
    }
    setLoaded(true);
  }
  return (
    <>
      <div className="single-product">
        <img src={props.img} className="product-img" />
        <div className="product-info-holder">
          {publicLink}
          {template}
          <DownloadButton
            url={
              "https://cdn.mmods.es/descargas/archivos?download=" +
              props.download
            }
          />
          {redeemed}
          {updated}
        </div>
      </div>
    </>
  );
}
export const meses = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];

function DownloadButton(props) {
  return (
    <>
      <div className="btn-holder">
        <a rel="noreferrer" target="_blank" href={props.url}>
          <div className="button">{<AiOutlineDownload />} Descargar</div>
        </a>
      </div>
    </>
  );
}

export function CatModHolder(props) {
  const [publicLink, setPublicLink] = useState();
  let productDate = new Date(props.create_time);
  const meses = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];
  productDate =
    productDate.getDate() +
    " de " +
    meses[productDate.getMonth()] +
    " del " +
    productDate.getFullYear();
  const [updated, setUpdated] = useState();
  const [loaded, setLoaded] = useState(false);
  const [isNew, newBadge] = useState(<></>);
  const [update, setUpdate] = useState(<></>);
  const [shoppy, setShoppy] = useState(<></>);
  const [createdText, setCreated] = useState(<></>);
  const [month, setMonth] = useState(<></>);
  useEffect(
    (e) => {
      props.public
        ? setPublicLink(
            <>
              {isNew}
              {update}
              <a
                title="Ver producto en Shoppy"
                href={props.public}
                target="_blank"
                rel="noreferrer"
                className="product-title underlined"
              >
                <h2 className="product-title search-content">{props.name}</h2>
              </a>
            </>,
          )
        : setPublicLink(
            <h2 className="product-title search-content">
              {isNew}
              {update}
              {props.name}
            </h2>,
          );
    },
    [isNew],
  );
  if (!loaded) {
    props.month ? setMonth(<MonthModBadge id={props.id} />) : setMonth(<></>);
    props.update_time != props.create_time
      ? setUpdate(
          <span
            title="Este mod ha recibido actualizaciones"
            className="new-badge update-badge"
          >
            Actualizado
          </span>,
        )
      : setUpdate(<></>);
    if (props.isNew == true)
      newBadge(
        <span
          title="Este mod se creó hace menos de 1 mes"
          className="new-badge"
        >
          Nuevo
        </span>,
      );
    if (props.updated)
      setUpdated(
        <span
          title="Este mod ha recibido actualizaciones"
          className="new-badge updated-badge"
        >
          Actualizado
        </span>,
      );
    props.public
      ? setPublicLink(
          <>
            {isNew}
            <a
              title="Ver producto en Shoppy"
              href={props.public}
              target="_blank"
              rel="noreferrer"
              className="product-title underlined"
            >
              <h2 className="product-title">{props.name}</h2>
            </a>
          </>,
        )
      : setPublicLink(
          <h2 className="product-title">
            {isNew}
            {props.name}
          </h2>,
        );
    props.shoppy
      ? setShoppy(
          <>
            <a
              target={"_blank"}
              rel="noreferrer"
              href={props.shoppy}
              className="shoppy-a"
            >
              <span className="shoppy-badge">
                Ver en DigitalShelf{<BiLinkExternal />}
              </span>
            </a>
          </>,
        )
      : setShoppy(<></>);
    setLoaded(true);
    setCreated(<p>Mod publicado el {props.created_text}</p>);
  }
  if (loaded && !props.loading) {
    return (
      <>
        <div className="single-product">
          <img className="product-img" src={props.img} />
          <div className="product-info-holder">
            {publicLink}
            {createdText}
            {shoppy}
          </div>
        </div>
      </>
    );
  } else {
    return <SkeletonLoader />;
  }
}

export function CatSingleMod(props) {
  const [publicLink, setPublicLink] = useState();
  let productDate = new Date(props.create_time);
  const meses = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];
  productDate =
    productDate.getDate() +
    " de " +
    meses[productDate.getMonth()] +
    " del " +
    productDate.getFullYear();
  const [updated, setUpdated] = useState();
  const [loaded, setLoaded] = useState(false);
  const [isNew, newBadge] = useState(<></>);
  const [update, setUpdate] = useState(<></>);
  const [shoppy, setShoppy] = useState(<></>);
  const [img, setImg] = useState(props.img);
  const [created, setCreated] = useState(<></>);
  const [month, setMonth] = useState(<></>);
  if (!loaded) {
    /[a-zA-Z]+/.test(props.img)
      ? setImg(props.img)
      : setImg("https://mmods.es/cdn/img/logo.png");
    props.month ? setMonth(<MonthModBadge id={props.id} />) : setMonth(<></>);
    props.isNew
      ? newBadge(
          <span
            title="Este mod se creó hace menos de 1 mes"
            className="new-badge"
          >
            Nuevo
          </span>,
        )
      : newBadge(<></>);
    props.updated
      ? setUpdate(
          <span
            title="Este mod ha recibido actualizaciones"
            className="new-badge update-badge"
          >
            Actualizado
          </span>,
        )
      : setUpdate(<></>);
    setPublicLink(props.name);
    setCreated(<p>Mod publicado el {props.created_text}</p>);
    props.shoppy
      ? setShoppy(
          <>
            <a
              target={"_blank"}
              rel="noreferrer"
              href={props.shoppy}
              className="shoppy-a"
            >
              <span className="shoppy-badge">
                Ver en DigitalShelf{<BiLinkExternal />}
              </span>
            </a>
          </>,
        )
      : setShoppy(<></>);
    setLoaded(true);
  }
  if (props.loading) {
    return <SkeletonLoader />;
  } else {
    return (
      <>
        <div className="single-product">
          <SkeletonImg setid={props.id} />
          <img
            id={"new-img-id-" + props.id}
            className="product-img invisible"
            src={img}
          />
          <div className="product-info-holder">
            <h2 className="product-title search-content">
              {month}
              {isNew}
              {update}
              {publicLink}
            </h2>
            {created}
            {shoppy}
          </div>
        </div>
      </>
    );
  }
}

export function SkeletonLoader(props) {
  return (
    <>
      <div className="single-product">
        <div className="skeleton-img" />
        <div className="product-info-holder">
          <span className="product-title skeleton-title"></span>
        </div>
      </div>
    </>
  );
}

export function SkeletonImg(props) {
  return <div className="skeleton-img" id={"new-skeleton-id-" + props.setid} />;
}

function MonthModBadge(props) {
  if (props.id) {
    return (
      <span
        id={"month-mod-" + props.id}
        title="Este mod es el mod gratuito para donadores de este mes"
        className="month-mod-badge clickable"
      >
        <BsStarFill />
      </span>
    );
  } else {
    return (
      <a
        href="https://mmodsgtav.com/donadores"
        target={"_blank"}
        rel="noreferrer"
        title="Este mod es el mod gratuito para donadores de este mes"
        className="month-mod-badge"
      >
        <BsStarFill />
      </a>
    );
  }
}
export function MonthContext() {
  return (
    <div id="mensual-mod-context" className="supremo notvisible">
      <div className="all-context-wrapper">
        <div className="content">
          <div className="month-mod-big-holder">
            <MonthModBadge />
          </div>
          <h1>Mod del mes</h1>
          <p className="support-text">
            Este mod es gratis durante este mes para los donadores recientes.
            Cada mes un mod gratuito diferente es seleccionado automáticamente.
          </p>
          <a
            className="support-text support-link"
            href="https://mmodsgtav.com/donadores"
          >
            Más información.
          </a>
          <close
            id="click-context-dialog"
            onClick={(e) => {
              document.querySelector("#mensual-mod-context").className =
                "supremo notvisible";
            }}
          >
            Cerrar
          </close>
        </div>
      </div>
    </div>
  );
}

export function FlotingWindow(props) {
  return (
    <div className="centered-window">
      <div className="centered-content">
        <div className="floating-window">
          <h1>{props.title}</h1>
          <p>{props.desc}</p>
          <Social />
          <span className="btn-holder-window">
            <close>Rechazar</close>
            <close>Aceptar</close>
          </span>
        </div>
      </div>
    </div>
  );
}
